import { newApiRequest } from '@va/dashboard/reducers';
import * as Types from 'wix/actions/types';

export const activateDirectAccess = newApiRequest(
  Types.wix.Api.ACTIVATE_DIRECT_ACCESS_REQUEST,
  Types.wix.Api.ACTIVATE_DIRECT_ACCESS_SUCCEEDED,
  Types.wix.Api.ACTIVATE_DIRECT_ACCESS_FAILED,
);
